module.exports = __webpack_public_path__ + "static/media/1h.fde24cd7.jpg";